// extracted by mini-css-extract-plugin
export default {"suggestion":"styles_suggestion__FFGrW","active":"styles_active__eA0JB","icon":"styles_icon__zJVaS"};